// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-brand_container-rX3B8 {
  justify-content: center;
  margin: 72px auto 0px;
}

.login-card-ucDha {
  width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  padding: 28px;
  margin: 60px auto;
  background-color: var(--color-white);
}

.login-cardIcon-FkN4p {
  --size: 44px;
  margin-top: 8px;
  color: var(--color-neutral-800);
}

.login-cardTitle_container-UpzLN {
  margin-top: 16px;
}

.login-cardTitle_title-Vm2N2 {
  font-size: var(--text-xl);
  color: var(--color-neutral-800);
}

.login-form-T85Cr {
  width: 100%;
  margin-bottom: 24px;
}

.login-emailField_container-KF7fC {
  width: 100%;
  margin-top: 32px;
}

.login-passwordField_container-FanI5 {
  width: 100%;
  margin-top: 20px;
}

.login-button_base-InH0X {
  width: 100%;
  margin-top: 20px;
}

.login-signupContainer-h4p1f {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
}

.login-signupLabel-aYjXp {
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
}

.login-signupLink-QkvOy {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/login.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC","sourcesContent":[".brand_container {\n  justify-content: center;\n  margin: 72px auto 0px;\n}\n\n.card {\n  width: 360px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-xl);\n  padding: 28px;\n  margin: 60px auto;\n  background-color: var(--color-white);\n}\n\n.cardIcon {\n  --size: 44px;\n  margin-top: 8px;\n  color: var(--color-neutral-800);\n}\n\n.cardTitle_container {\n  margin-top: 16px;\n}\n\n.cardTitle_title {\n  font-size: var(--text-xl);\n  color: var(--color-neutral-800);\n}\n\n.form {\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.emailField_container {\n  width: 100%;\n  margin-top: 32px;\n}\n\n.passwordField_container {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.button_base {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.signupContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: 32px;\n}\n\n.signupLabel {\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n}\n\n.signupLink {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brand_container": `login-brand_container-rX3B8`,
	"card": `login-card-ucDha`,
	"cardIcon": `login-cardIcon-FkN4p`,
	"cardTitle_container": `login-cardTitle_container-UpzLN`,
	"cardTitle_title": `login-cardTitle_title-Vm2N2`,
	"form": `login-form-T85Cr`,
	"emailField_container": `login-emailField_container-KF7fC`,
	"passwordField_container": `login-passwordField_container-FanI5`,
	"button_base": `login-button_base-InH0X`,
	"signupContainer": `login-signupContainer-h4p1f`,
	"signupLabel": `login-signupLabel-aYjXp`,
	"signupLink": `login-signupLink-QkvOy`
};
export default ___CSS_LOADER_EXPORT___;
